module.exports = __webpack_public_path__ + "media/images/sp/reserve/calendar-dd9b99c186b65e10d198f80f87201c16.svg";